import { log } from "@dxos/log";
import * as localForage from "localforage";
import { compositeKey } from "@dxos/util";
//#region src/storage/browser.ts
var __dxlog_file = "/__w/dxos/dxos/packages/sdk/observability/src/storage/browser.ts";
var OBSERVABILITY_DISABLED_KEY = "observability-disabled";
var OBSERVABILITY_GROUP_KEY = "observability-group";
var OTEL_LOG_LEVEL_KEY = "otel-log-level";
/** No-op in browser contexts; the notice is a toast there. */
var showObservabilityBanner = async (_namespace, _bannercb) => {
	log.warn("showObservabilityBanner is not supported in browser contexts.", void 0, {
		"~LogMeta": "~LogMeta",
		F: __dxlog_file,
		L: 17,
		S: void 0
	});
};
/**
* @param namespace - localForage key prefix used to scope the observability state in browser storage.
*/
var isObservabilityDisabled = async (namespace) => {
	try {
		return await localForage.getItem(compositeKey(namespace, OBSERVABILITY_DISABLED_KEY)) === "true";
	} catch (err) {
		log.catch("Failed to check if observability is disabled, assuming it is", err, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file,
			L: 27,
			S: void 0
		});
		return true;
	}
};
/** Undefined in the browser: posthog-js mints and persists its own anonymous id. */
var getInstallationId = async (_namespace) => void 0;
/** No installation id in the browser, so nothing is ever aliased from one. */
var getAliasedDid = async (_namespace) => void 0;
var storeAliasedDid = async (_namespace, _did) => {};
/**
* @param namespace - localForage key prefix used to scope the observability state in browser storage.
*/
var storeObservabilityDisabled = async (namespace, value) => {
	try {
		await localForage.setItem(compositeKey(namespace, OBSERVABILITY_DISABLED_KEY), String(value));
	} catch (err) {
		log.catch("Failed to store observability disabled", err, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file,
			L: 47,
			S: void 0
		});
	}
	try {
		if (typeof localStorage !== "undefined") localStorage.setItem(`${namespace}/${OBSERVABILITY_DISABLED_KEY}`, String(value));
	} catch {}
};
/**
* @param namespace - localForage key prefix used to scope the observability state in browser storage.
*/
var getObservabilityGroup = async (namespace) => {
	try {
		return await localForage.getItem(compositeKey(namespace, OBSERVABILITY_GROUP_KEY)) ?? void 0;
	} catch (err) {
		log.catch("Failed to get observability group", err, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file,
			L: 67,
			S: void 0
		});
	}
};
/**
* @param namespace - localForage key prefix used to scope the observability state in browser storage.
*/
var storeObservabilityGroup = async (namespace, value) => {
	try {
		await localForage.setItem(compositeKey(namespace, OBSERVABILITY_GROUP_KEY), value);
	} catch (err) {
		log.catch("Failed to store observability group", err, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file,
			L: 78,
			S: void 0
		});
	}
};
/**
* @param namespace - localForage key prefix used to scope the observability state in browser storage.
*/
var getOtelLogLevel = async (namespace) => {
	try {
		return await localForage.getItem(compositeKey(namespace, OTEL_LOG_LEVEL_KEY));
	} catch (err) {
		log.catch("Failed to get OTEL log level", err, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file,
			L: 89,
			S: void 0
		});
		return null;
	}
};
/**
* @param namespace - localForage key prefix used to scope the observability state in browser storage.
*/
var storeOtelLogLevel = async (namespace, value) => {
	try {
		if (value === null) await localForage.removeItem(compositeKey(namespace, OTEL_LOG_LEVEL_KEY));
		else await localForage.setItem(compositeKey(namespace, OTEL_LOG_LEVEL_KEY), value);
	} catch (err) {
		log.catch("Failed to store OTEL log level", err, {
			"~LogMeta": "~LogMeta",
			F: __dxlog_file,
			L: 105,
			S: void 0
		});
	}
};
//#endregion
export { getAliasedDid, getInstallationId, getObservabilityGroup, getOtelLogLevel, isObservabilityDisabled, showObservabilityBanner, storeAliasedDid, storeObservabilityDisabled, storeObservabilityGroup, storeOtelLogLevel };

//# sourceMappingURL=storage.mjs.map